import { BASELINE_CYCLE } from "./getCycle";

/** The visible label of a cycle number, such as "Cycle 22" or "Baseline". */
export const formatCycle = (cycle: number) =>
  cycle === BASELINE_CYCLE ? "Baseline" : `Cycle ${cycle}`;
